import {
    SYSTEM_GET_SALARYTYPE_LIST_BEGIN,
    SYSTEM_GET_SALARYTYPE_LIST_SUCCESS,
    SYSTEM_GET_SALARYTYPE_LIST_FAILURE,
    SYSTEM_GET_SALARYTYPE_LIST_DISMISS_ERROR,
  } from './constants';
  
  import request from '../../../utils/request'
  // Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
  // If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
  export function getSalaryTypeList(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: SYSTEM_GET_SALARYTYPE_LIST_BEGIN,
      });
     params.size = 10;

     const promise = new Promise((resolve, reject) => {
          request({
            method:'post',
            url:'/api/b/salaryType/list',
            data:params,
          }).then( data => {
              dispatch({
                  type: SYSTEM_GET_SALARYTYPE_LIST_SUCCESS,
                  data: Object.assign({},data,{page:params.page}),
              });
              resolve(data);
          }).catch (error => {
              dispatch({
                type: SYSTEM_GET_SALARYTYPE_LIST_FAILURE,
                data: { error: error },
              });
              reject(error);
          })
      });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissGetSalaryTypeListError() {
    return {
      type: SYSTEM_GET_SALARYTYPE_LIST_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_GET_SALARYTYPE_LIST_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          getSalaryTypeListPending: true,
          getSalaryTypeListError: null,
        };
  
      case SYSTEM_GET_SALARYTYPE_LIST_SUCCESS:
        // The request is success
  
        const byId = {};
        const items = [];
        action.data.list.forEach(item => {
          items.push(item.id);
          byId[item.id] = item;
        });
        return {
          ...state,
          salaryTypeById:byId,
          salaryTypeList:items,
          salaryTypePage: action.data.page,
          salaryTypeSize: action.data.size,
          salaryTypeTotal: action.data.count,
          getSalaryTypeListPending: false,
          getSalaryTypeListError: null,
        };
  
      case SYSTEM_GET_SALARYTYPE_LIST_FAILURE:
        // The request is failed
        return {
          ...state,
          getSalaryTypeListPending: false,
          getSalaryTypeListError: action.data.error,
        };
  
      case SYSTEM_GET_SALARYTYPE_LIST_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          getSalaryTypeListError: null,
        };
  
      default:
        return state;
    }
  }


// WEBPACK FOOTER //
// ./src/features/system/redux/getSalaryTypeList.js